'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UsageDataService = function () {
  function UsageDataService($http) {
    'ngInject';

    _classCallCheck(this, UsageDataService);

    this.$http = $http;
  }

  _createClass(UsageDataService, [{
    key: 'getMissingUsageData',
    value: function getMissingUsageData() {
      return this.$http.get('/api/usage/all_missing_usage');
    }
  }, {
    key: 'getMissingQuarterUsageData',
    value: function getMissingQuarterUsageData() {
      return this.$http.get('/api/usage/all_missing_usage_current_qarter');
    }
  }, {
    key: 'getQ4Value',
    value: function getQ4Value(productId, year) {
      return this.$http.get('/api/usage/q4_value/' + productId + '/' + year);
    }
  }, {
    key: 'getMissingProductUsageData',
    value: function getMissingProductUsageData(productId) {
      return this.$http.get('/api/usage/product_missing_usage/' + productId);
    }
  }, {
    key: 'updateMissingUsageData',
    value: function updateMissingUsageData(usages) {
      return this.$http.post('/api/usage/update_missing_usage', {
        usages: usages
      });
    }
  }]);

  return UsageDataService;
}();

exports.default = UsageDataService;


// WEBPACK FOOTER //
// ./services/usage-data.service.js